/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from 'react';

import { Popover, Transition } from '@headlessui/react';
import { CSVLink } from 'react-csv';
import { HiDocumentDownload } from 'react-icons/hi';

import { Itransaction } from '@/modules/core/types';
import Button from '@/tayara-kit/Button';

type CsvData = string[][];

const exportOptions = [
  {
    name: 'CSV',
    description: "Exporter l'éxtrait en format '.csv'",
    onClick: () => {},
  },
  /* {
    name: 'PDF',
    description: "Exporter l'éxtrait en format '.pdf'",
    onClick: () => {},
  }, */
];

const mapItransctionToCsvData = (transactionList: Itransaction[]): CsvData =>
  transactionList!.map((iTransaction) => {
    const dateObject = new Date(iTransaction.createdTime!);
    const dateString = dateObject.toLocaleString();
    return [
      dateString,
      `${iTransaction.isVirement ? '+' : '-'} ${iTransaction.amount!}`,
      iTransaction.description!,
    ];
  });

const csvHeaders = ['Date', 'Montant', 'Description'];

interface Props {
  transactionList: Itransaction[];
}
const DownloadReceipts = (props: Props) => {
  const [csvData, setCsvData] = useState<CsvData>([csvHeaders]);
  useEffect(() => {
    setCsvData([csvHeaders, ...mapItransctionToCsvData(props.transactionList)]);
  }, [props.transactionList]);

  return (
    <div>
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button className="w-full">
              <Button
                aria-label="Télécharger l'extrait"
                className={`
                  ${open ? '' : 'text-opacity-90'}
                  btn-sm text-info bg-transparent hover:bg-info/10 hover:text-blue-700`}
                icon={<HiDocumentDownload size={24} />}
              >
                Télécharger l&apos;éxtrait
              </Button>
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute left-1/2 z-10 mt-3 w-64 max-w-sm -translate-x-1/2 transform px-4 sm:px-0 ">
                <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="relative grid gap-8 bg-white p-7">
                    {exportOptions.map((item) => (
                      <CSVLink
                        data={csvData!}
                        key={item.name}
                        filename={'extrait-transactions-tayara.csv'}
                      >
                        <a
                          className="cursor-pointer -m-3 flex items-center rounded-lg py-1 \
                          transition duration-150 ease-in-out hover:bg-gray-50 \
                          focus:outline-none focus-visible:ring \
                          focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                          onClick={item.onClick}
                        >
                          <div className="ml-4">
                            <p className="text-sm font-medium text-gray-900">
                              {item.name}
                            </p>
                            <p className="text-sm text-gray-500">
                              {item.description}
                            </p>
                          </div>
                        </a>
                      </CSVLink>
                    ))}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
};

export default DownloadReceipts;
